import React from "react";
import { Typography, Space } from "antd";
import GeneralCard from "@/components/card/GeneralCard";
import "@/styles/pages/common/termsandcondition.scss";

const { Title, Paragraph, Link } = Typography;

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-wrapper">
      <GeneralCard>
        <div className="privacy-policy container">
          <Space direction="vertical" size="medium" className="privacy-space">
            <Title level={2} className="center" style={{ marginBottom: "35px" }}>
              Inforens Privacy Policy
            </Title>

            <Title level={4}>Our Contact Details</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              Name: Inforens Global Ltd
              <br />
              Companies House: 13915242
              <br />
              Phone Number: +44 7587 039853
              <br />
              E-mail:{" "}
              <Link href="mailto:support@inforens.com" style={{ textDecoration: "underline" }}>
                support@inforens.com
              </Link>
            </Paragraph>

            <Paragraph>
              The Company is committed to processing data in accordance with its responsibilities
              under the GDPR.
              <br />
              <br />
              We currently collect and process the following information:
              <ul style={{ listStyleType: "disc" }}>
                <li>Name</li>
                <li>Phone number</li>
                <li>Address</li>
                <li>Email address</li>
                <li>Bank Account details</li>
                <li>Any other employee/intern/volunteer data</li>
              </ul>
              Most of the personal information we process is provided to us directly by you for one
              of the following reasons:
              <ul style={{ listStyleType: "disc" }}>
                <li>Payroll</li>
                <li>Reimbursements, etc.</li>
              </ul>
            </Paragraph>

            <Paragraph>
              <span>
                Your information is securely stored and accessed by the Director/Founder and the
                relevant department manager.
              </span>
              <br />
              <span>
                We will destroy all internal data relating to supporters and the public no greater
                than six years after we have last heard from them.
              </span>
              <br />
              <br />
              <span>Reason for keeping personal data for six years:</span>
              <ul style={{ listStyleType: "disc" }}>
                <li>We have a contractual obligation.</li>
                <li>We have a legal obligation.</li>
                <li>We have a vital interest.</li>
                <li>We need it to perform a public task.</li>
                <li>We have a legitimate interest.</li>
              </ul>
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              You are able to remove your consent at any time. You can do this by contacting{" "}
              <Link href="mailto:support@inforens.com" style={{ textDecoration: "underline" }}>
                support@inforens.com
              </Link>
            </Paragraph>
            <Title level={4}>Your data protection rights</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              <span>Under data protection law, you have rights including:</span>
              <br />
              <br />
              <span>
                Your right of access - You have the right to ask us for copies of your personal
                information.
              </span>
              <br />
              <br />
              <span>
                Your right to rectification - You have the right to ask us to rectify personal
                information you think is inaccurate. You also have the right to ask us to complete
                information you think is incomplete.
              </span>
              <br />
              <br />
              <span>
                Your right to erasure - You have the right to ask us to erase your personal
                information in certain circumstances.
              </span>
              <br />
              <br />
              <span>
                Your right to restriction of processing - You have the right to ask us to restrict
                the processing of your personal information in certain circumstances.
              </span>
              <br />
              <br />
              <span>
                Your right to object to processing - You have the the right to object to the
                processing of your personal information in certain circumstances.
              </span>
              <br />
              <br />
              <span>
                Your right to data portability - You have the right to ask that we transfer the
                personal information you gave us to another organisation, or to you, in certain
                circumstances.
              </span>
              <br />
              <br />
              <span>
                You are not required to pay any charge for exercising your rights. If you make a
                request, we have one month to respond to you.
              </span>
              <br />
              <br />
              <span>
                Please contact us at{" "}
                <Link href="mailto:support@inforens.com" style={{ textDecoration: "underline" }}>
                  support@inforens.com
                </Link>{" "}
                if you wish to make a request.
              </span>
            </Paragraph>

            <Paragraph style={{ fontStyle: "italic", color: "gray" }}>
              <span style={{ fontWeight: 600, color: "black" }}>Children's Privacy:</span>
              <span style={{ marginLeft: "5px" }}>
                Our website, app and services are not aimed at children. We do not target, intend to
                collect, or knowingly collect or otherwise process information from any Child.
              </span>
              <br />
              <br />
              <span>
                If you are under the age of 18 years, we request that you do not provide us with
                your information and do not use our website and app. If you are a parent or guardian
                of a child under 18 years, please contact us if you are aware that your child has
                used our website or app or otherwise provided their information to us without your
                consent.
              </span>
              <br />
              <br />
              <span>
                We shall erase or otherwise cease processing your child’s personal information
                within a reasonable time to make sure that we do not contact you in the future.
              </span>
            </Paragraph>
          </Space>
        </div>
      </GeneralCard>
    </div>
  );
};

export default PrivacyPolicy;
